export default "__VITE_ASSET__3gmiSnVT__"